import React, { useState, useEffect } from 'react';

import './index.css';
import axios from '../../store/axios';
import logo from '../../static/img/logo.png';

const PlanOffer = ({ match, location }) => {
  const token = match['params']['token'];
  const isSuccess = new URLSearchParams(location['search']).get('status') === 'success';

  const [ui, setUi] = useState({ loading: true, paying: false, notFound: false, error: '', plan: null });
  const updateUi = (patch) => setUi(prev => ({ ...prev, ...patch }));

  useEffect(() => {
    const fetchPlan = async () => {
      try {
        const response = await axios.get(`/payment/custom-plan/${token}`);
        if (response['data']['code'] === 200) updateUi({ loading: false, plan: response['data']['body'] });
        else updateUi({ loading: false, notFound: true });
      } catch (error) {
        updateUi({ loading: false, notFound: true });
      }
    };
    fetchPlan();
  }, [token]);

  const handlePay = async () => {
    updateUi({ paying: true, error: '' });
    try {
      const response = await axios.post(`/payment/custom-plan/${token}/checkout`);
      if (response['data']['code'] === 200 && response['data']['body']?.['url']) window.location = response['data']['body']['url'];
      else updateUi({ paying: false, error: response['data']['message'] || 'Unable to start checkout. Please try again.' });
    } catch (error) {
      updateUi({ paying: false, error: error['response']?.['data']?.['message'] || 'Unable to start checkout. Please try again.' });
    }
  };

  const plan = ui['plan'];

  return (
    <div className='plan-offer-page'>
      <div className='plan-offer-header'>
        <img alt='Logo' src={logo} className='plan-offer-logo' />
      </div>

      {ui['loading'] ? (
        <div className='plan-offer-card plan-offer-center'>
          <i className='fa fa-spinner fa-spin plan-offer-spinner'></i>
        </div>
      ) : isSuccess ? (
        <div className='plan-offer-card plan-offer-center'>
          <i className='fa fa-check-circle plan-offer-success-icon'></i>
          <h3 className='plan-offer-title'>Payment received!</h3>
          <p className='plan-offer-text'>Your workspace is being set up. Check your email for a link to set your password and get started.</p>
        </div>
      ) : ui['notFound'] || !plan ? (
        <div className='plan-offer-card plan-offer-center'>
          <i className='fa fa-info-circle plan-offer-muted-icon'></i>
          <h3 className='plan-offer-title'>Plan not found</h3>
          <p className='plan-offer-text'>This plan link is invalid or no longer available. Please contact your account manager.</p>
        </div>
      ) : (
        <div className='plan-offer-card'>
          <h5 className='plan-offer-name'>{plan['displayName']}</h5>
          <h2 className='plan-offer-price'>${Number(plan['price']).toLocaleString()}<span>/{plan['interval'] || 'month'}</span></h2>
          {plan['description'] && <p className='plan-offer-desc'>{plan['description']}</p>}

          {plan['discountPercent'] > 0 && (
            <div className='plan-offer-discount'>
              <i className='fa fa-tag'></i>
              {plan['discountPercent']}% off your first month — applied automatically at checkout
            </div>
          )}

          {plan['isPurchased'] ? (
            <div className='plan-offer-status'>This plan has already been purchased.</div>
          ) : !plan['isAvailable'] ? (
            <div className='plan-offer-status'>This plan is not currently available. Please contact your account manager.</div>
          ) : (
            <>
              <button className='btn-style-new plan-offer-pay-btn' onClick={handlePay} disabled={ui['paying']}>
                {ui['paying'] ? <i className='fa fa-spinner fa-spin icon' /> : <><i className='fa fa-lock mr-2'></i>Pay with Stripe</>}
              </button>
              {ui['error'] && <div className='plan-offer-error'>{ui['error']}</div>}
            </>
          )}

          <ul className='plan-offer-features'>
            {(plan['featuresWithIcons'] || []).filter(feature => feature['text']).map((feature, idx) => (
              <li key={idx}><i className='fa fa-check'></i>{feature['text']}</li>
            ))}
          </ul>

          <p className='plan-offer-footnote'>
            <i className='fa fa-shield mr-1'></i>
            Secure payment powered by Stripe. Your workspace is created automatically after payment.
          </p>
        </div>
      )}
    </div>
  );
};

export default PlanOffer;
